module.exports = __webpack_public_path__ + "img/my_qrcode_ins.2886396.png";